import React from "react";
import { Link } from "react-router-dom";
export default function TrustSection() {
  return (
    <section className="trust-section section">
      <div className="container support-grid">
        <div>
          <p className="eyebrow">INFORMATION</p>
          <h2>
            安心して、
            <br />
            お取引いただくために。
          </h2>
        </div>
        <div className="support-links">
          <Link to="/faqplus">
            <span>GUIDE</span>
            <div>
              <h3>偽造品の流通にご注意ください</h3>
              <p>偽物ウイスキーの見分け方・ホログラムシールの確認ポイント</p>
            </div>
            <b>↗</b>
          </Link>
          <Link to="/faq">
            <span>FAQ</span>
            <div>
              <h3>よくあるご質問</h3>
              <p>お取引条件・配送・お支払いについて</p>
            </div>
            <b>↗</b>
          </Link>
        </div>
      </div>
    </section>
  );
}
